/*
  Reality Romance - editable content layer.
  Content comes from the theme editor (Online Store > Themes > Customize > "Reality Romance" section)
  via window.RR_EDIT, which sections/rr-home.liquid writes. This file only displays it:
  - About page: heading, text, picture, contact email
  - Homepage video
  - Logo (also passed to the site as window.RR_WORDMARK)
*/
(function () {
  var C = window.RR_EDIT || {};
  var A = C.about || {};

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var css = [
    '[data-screen-label="ABOUT"].rr-ed-on > :not(.rr-ed-about){display:none !important;}',
    '.rr-ed-about{padding:clamp(40px,7vw,110px) clamp(14px,2.6vw,34px) clamp(50px,8vw,120px);}',
    '.rr-ed-h{margin:0;max-width:1400px;font-family:"Unbounded",system-ui,sans-serif;font-weight:800;',
    'font-size:clamp(28px,5.2vw,80px);line-height:1.02;letter-spacing:-.01em;text-transform:uppercase;}',
    '.rr-ed-text{margin-top:clamp(28px,4vw,56px);max-width:62ch;font-family:"Manrope",system-ui,sans-serif;',
    'font-weight:500;font-size:clamp(15px,1.35vw,20px);line-height:1.7;}',
    '.rr-ed-text p{margin:0 0 1.1em;}',
    '.rr-ed-text a{text-decoration:underline;}',
    '.rr-ed-img{margin-top:clamp(36px,5vw,80px);}',
    '.rr-ed-img img{display:block;width:100%;max-width:1400px;height:auto;}',
    '.rr-ed-contact{margin-top:clamp(40px,5vw,80px);font-family:"Manrope",system-ui,sans-serif;}',
    '.rr-ed-label{font:10px ui-monospace,Menlo,monospace;letter-spacing:.2em;opacity:.5;margin-bottom:12px;}',
    '.rr-ed-contact a{font-weight:800;font-size:clamp(15px,1.4vw,20px);}'
  ].join('');

  function addStyle() {
    if (document.getElementById('rr-ed-style')) return;
    var st = document.createElement('style');
    st.id = 'rr-ed-style';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  function aboutBlock() {
    var d = document.createElement('div');
    d.className = 'rr-ed-about';
    var h = '<style>' + css + '</style>';
    if (A.heading) h += '<h1 class="rr-ed-h">' + esc(A.heading) + '</h1>';
    if (A.html) h += '<div class="rr-ed-text">' + A.html + '</div>';
    if (A.image) h += '<div class="rr-ed-img"><img src="' + esc(A.image) + '" alt="' + esc(A.imageAlt) + '" loading="lazy"></div>';
    if (A.contact && C.email) {
      h += '<div class="rr-ed-contact"><div class="rr-ed-label">SAY HI</div>' +
        '<a href="mailto:' + esc(C.email) + '">' + esc(String(C.email).toUpperCase()) + '</a></div>';
    }
    d.innerHTML = h;
    return d;
  }

  // The original site restarts its homepage video at 4.18s. For a replacement
  // video we ignore those script resets so the whole clip plays and loops.
  var ctDesc = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, 'currentTime');
  function freeLoop(v) {
    if (!ctDesc || v.__rrFree) return;
    v.__rrFree = true;
    try {
      Object.defineProperty(v, 'currentTime', {
        configurable: true,
        get: function () { return ctDesc.get.call(this); },
        set: function () { /* ignored: native loop handles restarts */ }
      });
    } catch (e) {}
  }

  function apply() {
    addStyle(); // the site rebuilds <head> while loading, so keep our styles there
    // About page
    if (A.on) {
      var screens = document.querySelectorAll('[data-screen-label="ABOUT"]');
      for (var i = 0; i < screens.length; i++) {
        var el = screens[i];
        var have = null;
        for (var k = 0; k < el.children.length; k++) {
          if (el.children[k].className === 'rr-ed-about') { have = el.children[k]; break; }
        }
        if (!have) el.appendChild(aboutBlock());
        if (!el.classList.contains('rr-ed-on')) el.classList.add('rr-ed-on');
      }
    }
    // Homepage video
    if (C.heroVideo) {
      var vids = document.querySelectorAll('video');
      for (var j = 0; j < vids.length; j++) {
        var v = vids[j];
        var src = v.getAttribute('src') || '';
        if (src.indexOf('rr-hero-loop') > -1) {
          freeLoop(v);
          v.loop = true;
          v.muted = true;
          v.setAttribute('src', C.heroVideo);
          try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
        }
      }
    }
    // Logo (fallback in case the site did not pick up window.RR_WORDMARK)
    if (C.logo) {
      var imgs = document.querySelectorAll('img[src*="rr-wordmark"]');
      for (var m = 0; m < imgs.length; m++) {
        if (imgs[m].getAttribute('src') !== C.logo) imgs[m].setAttribute('src', C.logo);
      }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; apply(); });
  }

  function start() {
    addStyle();
    apply();
    try {
      new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {
      setInterval(apply, 500);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
